class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      { id: 'cart-drawer', selector: '#CartDrawer' },
      { id: 'cart-icon-bubble' },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* ==========================================================================
   HARD LIMIT: The Mother FREE PROMOTION to qty 1 (NO blocking /cart/add)
   Product ID: 14772693172587
   Variant IDs observed: 52589380239723, 52621976895851
   ========================================================================== */
(() => {
  // Prevent double-install
  if (window.__MOTHER_LIMITER_INSTALLED__) return;
  window.__MOTHER_LIMITER_INSTALLED__ = true;

  const RESTRICTED_PRODUCT_ID = '14772693172587';
  const RESTRICTED_VARIANTS = ['52589380239723', '52621976895851'];
  const MAX_QTY = 1;
  const MSG = 'This promotional item is limited to 1 per order.';
  const INTERNAL_PARAM = 'mother_limit=1';

  const nativeFetch = window.fetch.bind(window);

  // -----------------------------------------------------------------------
  // XHR INTERCEPT — catches Zipify OCU cart drawer (uses XMLHttpRequest)
  // Wraps open() + send() to clamp The Mother to qty 1 on change/update calls
  // -----------------------------------------------------------------------
  const NativeXHR = window.XMLHttpRequest;
  window.XMLHttpRequest = function () {
    const xhr = new NativeXHR();
    let _url = '';
    let _xhrEnforceAfter = false;

    const origOpen = xhr.open.bind(xhr);
    xhr.open = function (method, url, ...rest) {
      _url = String(url || '').toLowerCase();
      return origOpen(method, url, ...rest);
    };

    const origSend = xhr.send.bind(xhr);
    xhr.send = function (body) {
      const isCartMutation =
        _url.includes('/cart/change') ||
        _url.includes('/cart/update') ||
        _url.includes('/cart/add');

      if (!isCartMutation || !body || _url.includes(INTERNAL_PARAM)) {
        return origSend(body);
      }

      // Parse body and clamp if restricted variant found
      let clamped = false;
      try {
        let parsed = null;
        if (typeof body === 'string') {
          try {
            parsed = JSON.parse(body);
          } catch {
            // URL-encoded
            const p = new URLSearchParams(body);
            const id = p.get('id') || p.get('variant_id');
            const qty = p.get('quantity');
            if (id && qty && Number(qty) > MAX_QTY && isRestrictedVariant(id)) {
              p.set('quantity', String(MAX_QTY));
              body = p.toString();
              clamped = true;
            }
          }

          if (parsed) {
            // { id, quantity } — change.js
            if (parsed.id != null && parsed.quantity != null) {
              if (Number(parsed.quantity) > MAX_QTY && isRestrictedVariant(parsed.id)) {
                parsed.quantity = MAX_QTY;
                body = JSON.stringify(parsed);
                clamped = true;
              }
            }
            // { updates: { variantId: qty } } — update.js
            const updates = parsed.updates && typeof parsed.updates === 'object' ? parsed.updates : null;
            if (updates) {
              for (const [k, v] of Object.entries(updates)) {
                if (Number(v) > MAX_QTY && isRestrictedVariant(k)) {
                  updates[k] = MAX_QTY;
                  clamped = true;
                }
              }
              if (clamped) body = JSON.stringify(parsed);
            }
            // add.js: { id, quantity } or { items: [...] }
            if (_url.includes('/cart/add') && parsed.items) {
              parsed.items.forEach((item) => {
                if (Number(item.quantity) > MAX_QTY && isRestrictedVariant(item.id || item.variant_id)) {
                  item.quantity = MAX_QTY;
                  clamped = true;
                }
              });
              if (clamped) body = JSON.stringify(parsed);
            }
          }
        }
      } catch (e) {
        // Parse failed — pass through untouched
      }

      if (clamped) {
        alertOnce();
        _xhrEnforceAfter = true;
      }

      // After any cart mutation, run post-enforce (covers duplicate lines)
      if (isCartMutation) {
        xhr.addEventListener('load', () => {
          setTimeout(() => enforceTotalQtyIsOne({ showMessage: false }), 0);
        });
      }

      return origSend(body);
    };

    return xhr;
  };
  // Copy static properties (constants, prototype) from native XHR
  Object.assign(window.XMLHttpRequest, NativeXHR);
  window.XMLHttpRequest.prototype = NativeXHR.prototype;

  // Alert throttle: prevents popup loops
  let lastAlertAt = 0;
  const ALERT_COOLDOWN_MS = 1500;
  function alertOnce() {
    const now = Date.now();
    if (now - lastAlertAt < ALERT_COOLDOWN_MS) return;
    lastAlertAt = now;
    setTimeout(() => alert(MSG), 0);
  }

  function isRestrictedVariant(id) {
    return RESTRICTED_VARIANTS.includes(String(id));
  }

  async function fetchCart() {
    const r = await nativeFetch(`/cart.js?${INTERNAL_PARAM}`, { cache: 'no-store' });
    return r.json();
  }

  function getDrawerSectionsPayload() {
    return {
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname,
    };
  }

  async function changeLineByKey(key, quantity) {
    const body = JSON.stringify({
      id: key, // line-item key
      quantity,
      ...getDrawerSectionsPayload(),
    });

    const r = await nativeFetch(`/cart/change.js?${INTERNAL_PARAM}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
    });

    return r.json();
  }

  let enforcing = false;

  async function enforceTotalQtyIsOne({ showMessage } = {}) {
    if (enforcing) return;
    enforcing = true;

    try {
      const cart = await fetchCart();
      const lines = (cart.items || []).filter((it) => String(it.product_id) === RESTRICTED_PRODUCT_ID);
      if (!lines.length) return;

      const total = lines.reduce((sum, it) => sum + Number(it.quantity || 0), 0);
      const needsFix = total > MAX_QTY || lines.length > 1;
      if (!needsFix) return;

      // Keep first line, set to 1
      let state = null;
      const first = lines[0];

      if (Number(first.quantity) !== MAX_QTY) {
        state = await changeLineByKey(first.key, MAX_QTY);
      }

      // Remove all additional lines (can happen with properties/apps)
      for (let i = 1; i < lines.length; i++) {
        state = await changeLineByKey(lines[i].key, 0);
      }

      // Re-render drawer + header icon bubble if available
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function' && state && state.sections) {
        drawer.renderContents(state);
      } else if (state && state.sections) {
        // Fallback: update bubble even if drawer isn't present
        const bubble = document.getElementById('cart-icon-bubble');
        if (bubble && state.sections['cart-icon-bubble']) {
          bubble.innerHTML = new DOMParser()
            .parseFromString(state.sections['cart-icon-bubble'], 'text/html')
            .querySelector('.shopify-section')?.innerHTML || bubble.innerHTML;
        }
      }

      if (showMessage) alertOnce();
    } catch (e) {
      console.warn('[Mother limit] enforce failed', e);
    } finally {
      enforcing = false;
    }
  }

  // Clamp change/update payloads BEFORE they hit Shopify (prevents qty>1 from drawer, quick-add, etc.)
  async function clampChangeOrUpdate(resource, options) {
    if (!options || !options.body) return { options, clamped: false };

    const url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
    const lower = String(url).toLowerCase();
    const body = options.body;

    // Only for change/update
    if (!(lower.includes('/cart/change') || lower.includes('/cart/update'))) return { options, clamped: false };

    // JSON string
    if (typeof body === 'string') {
      try {
        const parsed = JSON.parse(body);

        // /cart/change.js: { id, quantity }
        if (parsed && parsed.id != null && parsed.quantity != null) {
          const desired = Number(parsed.quantity);
          if (desired > MAX_QTY) {
            // id may be variant OR line-item key. Variant is easy; key requires cart lookup.
            if (isRestrictedVariant(parsed.id)) {
              parsed.quantity = MAX_QTY;
              return { options: { ...options, body: JSON.stringify(parsed) }, clamped: true };
            }

            // If not obviously variant, try to see if id is a restricted line key
            try {
              const cart = await fetchCart();
              const match = (cart.items || []).find((it) => String(it.key) === String(parsed.id));
              if (match && String(match.product_id) === RESTRICTED_PRODUCT_ID) {
                parsed.quantity = MAX_QTY;
                return { options: { ...options, body: JSON.stringify(parsed) }, clamped: true };
              }
            } catch {
              // ignore
            }
          }
          return { options, clamped: false };
        }

        // /cart/update.js: { updates: { [idOrKey]: qty } } OR sometimes object itself
        const updates = parsed.updates && typeof parsed.updates === 'object' ? parsed.updates : parsed;
        let changed = false;

        for (const [idOrKey, qty] of Object.entries(updates || {})) {
          if (Number(qty) > MAX_QTY) {
            if (isRestrictedVariant(idOrKey)) {
              updates[idOrKey] = MAX_QTY;
              changed = true;
            } else {
              // Could be a line key
              try {
                const cart = await fetchCart();
                const match = (cart.items || []).find((it) => String(it.key) === String(idOrKey));
                if (match && String(match.product_id) === RESTRICTED_PRODUCT_ID) {
                  updates[idOrKey] = MAX_QTY;
                  changed = true;
                }
              } catch {
                // ignore
              }
            }
          }
        }

        if (changed) {
          const next = parsed.updates ? { ...parsed, updates } : updates;
          return { options: { ...options, body: JSON.stringify(next) }, clamped: true };
        }

        return { options, clamped: false };
      } catch {
        // URL-encoded fallback: id=...&quantity=...
        const params = new URLSearchParams(body);
        const id = params.get('id');
        const qty = params.get('quantity');

        if (id && qty && Number(qty) > MAX_QTY) {
          if (isRestrictedVariant(id)) {
            params.set('quantity', String(MAX_QTY));
            return { options: { ...options, body: params.toString() }, clamped: true };
          }

          // line-item key check
          try {
            const cart = await fetchCart();
            const match = (cart.items || []).find((it) => String(it.key) === String(id));
            if (match && String(match.product_id) === RESTRICTED_PRODUCT_ID) {
              params.set('quantity', String(MAX_QTY));
              return { options: { ...options, body: params.toString() }, clamped: true };
            }
          } catch {
            // ignore
          }
        }

        return { options, clamped: false };
      }
    }

    // FormData: id + quantity
    if (body instanceof FormData) {
      const id = body.get('id');
      const qty = body.get('quantity');
      if (id && qty && Number(qty) > MAX_QTY) {
        if (isRestrictedVariant(id)) {
          body.set('quantity', String(MAX_QTY));
          return { options, clamped: true };
        }

        try {
          const cart = await fetchCart();
          const match = (cart.items || []).find((it) => String(it.key) === String(id));
          if (match && String(match.product_id) === RESTRICTED_PRODUCT_ID) {
            body.set('quantity', String(MAX_QTY));
            return { options, clamped: true };
          }
        } catch {
          // ignore
        }
      }
    }

    return { options, clamped: false };
  }

  // SINGLE fetch wrapper (critical)
  window.fetch = async function (resource, options = {}) {
    const url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
    const lower = String(url).toLowerCase();

    // Never intercept our own internal requests
    if (lower.includes(INTERNAL_PARAM)) {
      return nativeFetch(resource, options);
    }

    const isAdd = lower.includes('/cart/add');
    const isChangeOrUpdate = lower.includes('/cart/change') || lower.includes('/cart/update');

    // 1) For change/update: clamp before sending
    if (isChangeOrUpdate) {
      const clamped = await clampChangeOrUpdate(resource, options);
      const res = await nativeFetch(resource, clamped.options);

      // If we clamped, show message once
      if (clamped.clamped) alertOnce();

      // Also enforce totals (covers duplicate-line edge cases)
      setTimeout(() => enforceTotalQtyIsOne({ showMessage: false }), 0);

      return res;
    }

    // 2) For add: DO NOT BLOCK. Let Dawn finish normally, then enforce if needed.
    if (isAdd) {
      const res = await nativeFetch(resource, options);

      // After add completes, enforce qty back to 1 if needed.
      // If enforcement had to fix something, it will show the popup.
      setTimeout(() => enforceTotalQtyIsOne({ showMessage: true }), 0);

      return res;
    }

    return nativeFetch(resource, options);
  };

  // Normalize on page load (silent)
  document.addEventListener('DOMContentLoaded', () => {
    enforceTotalQtyIsOne({ showMessage: false });
  });

  /* -----------------------------------------------------------------------
     /cart PAGE form-submit interceptor
     The fetch wrapper above only catches AJAX requests. The native /cart page
     submits an HTML form (POST to /cart) with quantity inputs — fetch never
     fires. We intercept the form submit event, clamp any restricted variant
     qty back to 1, and show the alert before the form is allowed to submit.
     ----------------------------------------------------------------------- */
  document.addEventListener('DOMContentLoaded', () => {
    // Only run on the /cart page
    if (!window.location.pathname.startsWith('/cart')) return;

    const form = document.querySelector('form[action="/cart"]');
    if (!form) return;

    form.addEventListener('submit', (e) => {
      let clamped = false;

      // Each qty input has name="updates[LINE_KEY]" or name="updates[]"
      // and a data-index or is identified by the variant id in a sibling hidden input
      // Strategy: find all qty inputs and check their associated variant id
      const inputs = form.querySelectorAll('input[name^="updates"]');

      inputs.forEach((input) => {
        // Find the nearest variant id — look for a sibling/ancestor with data-variant-id
        // or a hidden input named "id" in the same cart-item row
        const row = input.closest('[data-variant-id], .cart-item, tr');
        if (!row) return;

        const variantId =
          row.dataset.variantId ||
          (row.querySelector('[data-variant-id]') && row.querySelector('[data-variant-id]').dataset.variantId) ||
          (row.querySelector('input[name="id"]') && row.querySelector('input[name="id"]').value) ||
          // Fallback: extract variant id from the product link href (?variant=XXXXX)
          (() => {
            const link = row.querySelector('a.cart-item__link[href*="variant="]');
            if (!link) return null;
            const m = link.href.match(/[?&]variant=(\d+)/);
            return m ? m[1] : null;
          })();

        if (!variantId || !isRestrictedVariant(variantId)) return;

        const desired = parseInt(input.value, 10);
        if (isNaN(desired) || desired <= MAX_QTY) return;

        // Clamp to 1
        input.value = MAX_QTY;
        clamped = true;
      });

      if (clamped) {
        alertOnce();
        // Don't prevent — let the (now-clamped) form submit normally
      }
    });
  });
})();
